/**
 * Governance documents displays table with all
 * documents related to the selected category
 * in the TreeView located in the Governance component.
 * Nested component: CustomRowjs.
 * This component is loaded by selecting category in the TreeView.js nested in the Governance.js component.
 */

import React from 'react';
import store from '../../../../../stores/store';
import CustomRow from './CustomRow';
import { observer } from 'mobx-react';

const GovernanceDocuments = observer(
    class GovernanceDocuments extends React.Component {
        /**
         * On document click, it propagates to the Governance.js component
         * which is handling the even
         * @param  {number} Id clicked document Id
         */
        onDocumentClick = (Id, DocExtension, DocPermissions, DocName, DocAnnotations) => {
            if (this.props.onDocumentClick) {
                this.props.onDocumentClick(
                    Id,
                    DocExtension,
                    DocPermissions,
                    DocName,
                    DocAnnotations,
                );
            }
        };

        /**
         * It displays documents in a table. it gets the selectedDocuments array from the groups store.
         */
        displayTableRows = () => {
            let rows = [];

            if (store.groups.selectedGovCatId && store.groups.selectedDocuments.length > 0) {
                store.groups.selectedDocuments.forEach(
                    function(document, index) {
                        // console.log('document', document);
                        rows.push(
                            <CustomRow
                                onDocumentClick={this.onDocumentClick}
                                key={index}
                                Document={document}
                            />,
                        );
                        if (index === store.groups.selectedDocuments.length - 1 && ((document.DocExtension === "pdf" || document.Converted) && ((document.Converted && this.canDownloadNative(document.DocPermissions)) || this.canDownload(document.DocPermissions)))) {
                            rows.push(
                                     <tr key={index+1}><td scope="row"><div style={{"height" : "80px"}} /></td></tr>    
                            )
                        }
                    }.bind(this),
                );

                return rows;
            }
        };

        canDownload = permissions => {
            return ((permissions & 4) === 4)
        }
    
        canDownloadNative = permissions => {
            return ((permissions & 32) === 32)
        }

        render() {
            return (
                <div className="col pr-0">
                    <div className="table-responsive" id="document-table">
                        {store.groups.selectedGovCatId &&
                            store.groups.selectedDocuments.length > 0 && (
                                <table className="table table-bordered">
                                    <thead className="thead-default">
                                        <tr>
                                            <th>
                                                <span className="col pl-0 pr-3 document-th-label">
                                                    Document
                                                </span>
                                                {/*<button*/}
                                                {/*type="button"*/}
                                                {/*className="btn btn-outline-secondary btn-sm col-auto"*/}
                                                {/*>*/}
                                                {/*<i*/}
                                                {/*className="fa fa-download pr-2"*/}
                                                {/*aria-hidden="true"*/}
                                                {/*/>Download all documents*/}
                                                {/*</button>*/}
                                            </th>
                                            <th>Published</th>
                                        </tr>
                                    </thead>
                                    <tbody>{this.displayTableRows()}
                                    </tbody>
                                </table>
                            )}
                    </div>
                </div>
            );
        }
    },
);
export default GovernanceDocuments;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Dashboard/components/Governance/GovernanceDocuments.js